import { faHeart } from '@fortawesome/free-solid-svg-icons';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React, { useState, useEffect, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScreenBreakpoint, isMobileViewport } from '../../../helpers/screen';
import ThemeContext from '../../../providers/ThemeProvider';
import {
  addDealToWishlist,
  removeWishlistDeal,
} from '../../../redux/actions/wishlist';
import Icon from '../../Icon';

const WishlistIcon = ({
  dealId = null,
  left = false,
  toggle = false,
  mapViewLeft = false,
  mapViewCarousel = false,
}) => {
  const dispatch = useDispatch();
  const theme = useContext(ThemeContext);

  const breakpoint = useScreenBreakpoint();
  const [message, setMessage] = useState(false);
  const [toggled, setToggled] = useState(toggle);
  const [hover, setHover] = useState(false);
  const wishlist = useSelector((state) => state.wishlist.wishlist);
  const [isMobile, setIsMobile] = useState(false);

  const getWishlistedDeals = async () => {
    setToggled(wishlist?.some((deal) => dealId === deal.id));
  };

  useEffect(() => {
    getWishlistedDeals();
  }, [wishlist]);

  useEffect(() => {
    setIsMobile(isMobileViewport());
  }, [breakpoint]);

  const onDelete = (id) => {
    dispatch(removeWishlistDeal(id));
  };

  const onAdd = (id) => {
    dispatch(addDealToWishlist(id));
  };

  const handleClick = (id) => {
    if (toggled) {
      onDelete(id);
    } else {
      setMessage(true);
      setTimeout(() => {
        setMessage(false);
      }, 3_000);
      onAdd(id);
    }
    setToggled(!toggled);
  };

  const hoverCheck = (check) => {
    setHover(check && !toggled);
  };

  return (
    <>
      <div
        className={classNames('wishlist-icon', {
          'wishlist-icon--left': left,
          'wishlist-icon--map-view-carousel': mapViewCarousel,
          'wishlist-icon--map-view-left': mapViewLeft,
          'wishlist-icon--toggled': toggled,
          'wishlist-icon--untoggled': !toggled,
        })}
        data-qa="wishHeart"
        onClick={(event) => {
          event.stopPropagation();
          handleClick(dealId);
        }}
        onKeyDown={(event) => {
          event.stopPropagation();
          handleClick(dealId);
        }}
        onMouseEnter={() => hoverCheck(true)}
        onMouseLeave={() => hoverCheck(false)}
        role="button"
        tabIndex="0"
      >
        <Icon color={toggled ? '' : 'white'} faIcon={faHeart} />
        {hover && !isMobile && (
          <span
            className={classNames('message-container', {
              'message-container--left': left && !isMobile,
            })}
          >
            Add to Wishlist!
          </span>
        )}
        <span
          className={classNames('message-container', {
            'message-container--left': left && !isMobile,
            'message-hide': !message,
            'message-show': message,
          })}
        >
          Added to Wishlist!
        </span>
      </div>

      <style jsx>{`
        .wishlist-icon {
          cursor: pointer;
          margin: 10px 10px 0 0;
          position: absolute;
          right: 0;
          text-align: right;
          top: 0;
          width: 5%;
          z-index: 999;
        }
        .wishlist-icon--toggled {
          filter: drop-shadow(0 0 15px #fff);
        }
        .wishlist-icon--untoggled {
          filter: drop-shadow(0 0 15px #000);
        }
        .message-container {
          color: white;
          font-family: sans-serif;
          position: absolute;
          right: 25px;
          text-shadow: -1px -1px 4px grey, 0px -1px 4px grey, 1px -1px 4px grey,
            -1px 0px 4px grey, 1px 0px 4px grey, -1px 1px 4px grey,
            0px 1px 4px grey, 1px 1px 4px grey;
          top: 0px;
        }
        .message-show {
          transition: visibility 0.3s linear, opacity 0.3s linear;
        }
        .message-hide {
          visibility: hidden;
          opacity: 0;
          transition: visibility 0.3s linear, opacity 0.3s linear;
        }
        .wishlist-icon--map-view-left {
          right: 38px;
        }
        .wishlist-icon--map-view-carousel {
          right: 8px;
        }
        @media (min-width: ${theme.breakpoints.smUp}) {
          .wishlist-icon--left {
            margin: 10px 0 0 10px;
            right: 78px;
          }
        }
      `}</style>
    </>
  );
};

WishlistIcon.propTypes = {
  dealId: PropTypes.number,
  left: PropTypes.bool,
  mapViewCarousel: PropTypes.bool,
  mapViewLeft: PropTypes.bool,
  toggle: PropTypes.bool,
};

export default WishlistIcon;
